import { Col } from 'reactstrap';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ExpandButton, Modal } from 'mol-ui';
import { ModalContainer, Row, StyledCol, Text, Title } from './styled';

const NotificationModal = ({
    active,
    backCaption,
    caption,
    firstLine,
    height,
    onSubmit,
    onBack,
    padding = '0px 35px',
    secondLine,
    singleButton,
    title
}) => {

    const { t } = useTranslation();

    return (
        <Modal active={ active } onToggle={ onBack }>
            <ModalContainer height={ height } maxWidth="360px" minWidth="300px" padding={ padding }>
                <Row padding="5px 0px 10px 0px">
                    <Col>
                        <Title normal size="22px">{ title }</Title>
                    </Col>
                </Row>
                {
                    (firstLine || secondLine) &&
                    <Row padding="5px 0px 10px 0px">
                        <Col>
                            <Text>{ firstLine }</Text>
                            {
                                secondLine &&
                                <Text>{ secondLine }</Text>
                            }
                        </Col>
                    </Row>
                }
                <Row>
                    {
                        singleButton
                            ? <StyledCol xs="12">
                                <ExpandButton
                                    caption={ caption || t('Volver') }
                                    size={ 100 }
                                    onClick={ onBack }
                                />
                            </StyledCol>
                            : <>
                                <StyledCol xs="6">
                                    <ExpandButton
                                        secondary
                                        caption={ backCaption || t('Volver') }
                                        size={ 100 }
                                        onClick={ onBack }
                                    />
                                </StyledCol>
                                <StyledCol xs="6">
                                    <ExpandButton
                                        caption={ caption || t('Reintentar') }
                                        size={ 100 }
                                        onClick={ onSubmit }
                                    />
                                </StyledCol>
                            </>
                    }
                </Row>
            </ModalContainer>
        </Modal>
    );
};

NotificationModal.displayName = 'NotificationModal';

NotificationModal.propTypes = {
    active: PropTypes.bool,
    backCaption: PropTypes.string,
    caption: PropTypes.string,
    firstLine: PropTypes.string,
    height: PropTypes.string,
    onBack: PropTypes.func,
    onSubmit: PropTypes.func,
    padding: PropTypes.string,
    secondLine: PropTypes.string,
    singleButton: PropTypes.bool,
    title: PropTypes.string
};

export default NotificationModal;
